import { Plugin, PluginKey, type PMNode } from '@bangle.io/prosemirror-plugins';
import { type TextStats, textStats } from '@bangle.io/service-core';

const DOC_STATS_KEY = new PluginKey('sariz-doc-stats');
const DOC_STATS_DEBOUNCE_MS = 200;

export function statsFromDoc(doc: PMNode): TextStats {
  const text = doc.textBetween(0, doc.content.size, '\n');
  return textStats(text);
}

export function createDocStatsPlugin(
  onChange: (stats: TextStats) => void,
): Plugin {
  return new Plugin({
    key: DOC_STATS_KEY,
    view: (editorView) => {
      let timer: ReturnType<typeof setTimeout> | null = null;
      let pending: { state: { doc: PMNode } } | null = null;

      const emit = (doc: PMNode) => {
        onChange(statsFromDoc(doc));
      };

      // Seed totals immediately so the sidebar strip does not wait for a keystroke.
      emit(editorView.state.doc);

      return {
        update(view, prevState) {
          if (prevState && view.state.doc.eq(prevState.doc)) {
            return;
          }
          pending = view;
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            timer = null;
            const next = pending;
            pending = null;
            if (next) {
              emit(next.state.doc);
            }
          }, DOC_STATS_DEBOUNCE_MS);
        },
        destroy() {
          if (timer) {
            clearTimeout(timer);
          }
        },
      };
    },
  });
}
